export default "__VITE_ASSET__CaDh4__6__"